<template>
  <div class="offline-page">
    <top-bar>
      <template #left>&nbsp;</template>
      <div class="logo relative" >
        <environment-indicator class="absolute left-[50px] -top-1" />
        <pidz-logo />
      </div>
    </top-bar>
    <div class="layout">
      <div class="content">
        <app-loading class="loading-illustration" />
        <infinity-spinner class="spinner" />
        <p>Je hebt momenteel geen internetverbinding, daardoor is de app niet beschikbaar</p>
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>
import EnvironmentIndicator from '@app/components/EnvironmentIndicator.vue';
import InfinitySpinner from '@app/components/InfinitySpinner.vue';
import PidzLogo from '@app/components/PidzLogo.vue';
import TopBar from '@app/components/TopBar.vue';
import AppLoading from '@app/illustrations/AppLoading.vue';
</script>

<style lang="scss">
.offline-page {
  background-color: var(--pidz-blue);
  display: flex;
  width: 100%;
  flex-direction: column;

  .content {
    color: var(--pidz-white);
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    padding: 48px 32px;
    margin-top: 10vh;

    .spinner {
      margin-top: 60px;
      margin-bottom: 30px;
    }
  }
}
</style>
